<template>
  <div class="dropdown">
    <button class="btn btn-outline-primary dropdown-toggle m-0" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
      aria-expanded="false">
      {{ selectedItem ? `${selectedItem[displayKey]}` : placeholder }}
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <li>
        <input type="text" class="form-control" v-model="searchQuery" :placeholder="searchPlaceholder"
          @input="filterOptions">
      </li>

      <div class="options-list">
        <li v-for="item in filteredItems" :key="item[valueKey]">
          <a class="dropdown-item" href="#" @click="selectItem(item)" :class="item.disabled ? 'disabled' : null">
            {{ item[displayKey] }}
          </a>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Selecione uma opção'
    },
    searchPlaceholder: {
      type: String,
      default: 'Pesquisar...'
    },
    displayKey: {
      type: String,
      default: 'option'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    initialSelectedItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedItem: null
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(item =>
        item[this.displayKey]?.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item;
      this.searchQuery = '';
      this.$emit('update:modelValue', item[this.valueKey]);
      this.$emit('update:selectedItem', item[this.valueKey]);
      this.$emit('item-selected', item[this.valueKey]);
    }
  },
  watch: {
    items: {
      deep: true,
      immediate: true,
      async handler(newVal) {
        if (newVal && newVal.length > 0 && !this.selectedItem) {
          this.selectedItem = newVal.find(value => {
            return value[this.valueKey] == this.initialSelectedItem})
        }
      }
    },
    modelValue(newVal) {
      this.selectedItem = this.items.find(value => value[this.valueKey] === newVal) || null;
    },
    initialSelectedItem: {
      deep: true,
      immediate: true,
      async handler(newVal) {
        this.selectedItem = this.items.find(value => {
          return value[this.valueKey] == newVal})
      }
    },
  }
}
</script>

<style scoped>

.dropdown-toggle {
  width: 250px;
  overflow: hidden;
}

.dropdown-menu {
  min-width: 300px;
  overflow-y: auto;
}

.options-list {
  max-height: 350px;
  overflow: auto;
}

.form-control {
  width: 100%;
  margin-bottom: 10px;
}

.dropdown-item {
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #007bff;
  color: white;
}
</style>
